document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.cge-tab');
  if (!btn) return;

  const root = btn.closest('[data-cge-tabs="true"]');
  if (!root) return;

  const sectionId = root.getAttribute('data-section-id');
  const target = root.querySelector('[data-cge-items]');
  if (!sectionId || !target) return;

  const isReset = btn.hasAttribute('data-reset');
  const baseUrl = btn.getAttribute('data-fetch-url');

  if (!isReset && !baseUrl) return;

  e.preventDefault();

  root.querySelectorAll('.cge-tab').forEach((tab) => {
    const active = tab === btn;
    tab.classList.toggle('active', active);
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  const showLoading = () => {
    target.classList.add('is-loading');
    if (getComputedStyle(target).position === 'static') {
      target.style.position = 'relative';
    }
    if (!target.querySelector('.cge-loading-overlay')) {
      const overlay = document.createElement('div');
      overlay.className = 'cge-loading-overlay';
      overlay.innerHTML = '<div class="cge-spinner"></div>';
      target.appendChild(overlay);
    }
  };

  const hideLoading = () => {
    target.classList.remove('is-loading');
    target.querySelector('.cge-loading-overlay')?.remove();
  };

  const extractItems = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const shopifySection = doc.querySelector('#shopify-section-' + sectionId);
    if (!shopifySection) return null;
    const newTarget = shopifySection.querySelector('[data-cge-items]');
    return newTarget ? newTarget.innerHTML : null;
  };

  let url = '';

  if (isReset) {
    const resetUrl = root.querySelector('.section-heading a')?.getAttribute('href');
    if (!resetUrl) return;
    url = resetUrl;
  } else {
    url = baseUrl;
  }

  url += (url.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

  try {
    showLoading();
    const res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    const html = await res.text();
    const newItems = extractItems(html);

    if (newItems) {
      target.innerHTML = newItems;
    } else {
      console.warn('[CGE] no encontré data-cge-items en la respuesta');
    }
  } catch (err) {
    console.error('[CGE] ajax error', err);
  } finally {
    hideLoading();
  }
});